import * as React from 'react';

export const ConfirmIcon = () => (
  <svg
    width="50"
    height="50"
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_5373:33724)">
      <path
        d="M49.4006 40.6629L29.0939 4.61462C27.3624 1.46635 22.6399 1.46635 20.9082 4.61462L0.601646 40.6629C-1.12988 43.8112 1.07393 47.7466 4.69449 47.7466H45.1504C48.9283 47.5892 51.1322 43.8112 49.4006 40.6629Z"
        fill="#EB2323"
      />
      <path
        d="M25.0009 6.97583L45.3076 43.0241H4.69434L25.0009 6.97583Z"
        fill="white"
      />
      <path
        d="M21.6954 23.5045L22.9548 31.8476C23.1122 32.7921 23.8992 33.5791 25.0012 33.5791C25.9457 33.5791 26.8902 32.7921 27.0476 31.8476L28.307 23.5045C28.6218 21.4581 27.0476 19.7266 25.0012 19.7266C22.9547 19.7265 21.5379 21.4581 21.6954 23.5045Z"
        fill="#7A8FB8"
      />
      <path
        d="M25.001 39.0888C26.0443 39.0888 26.89 38.2431 26.89 37.1998C26.89 36.1565 26.0443 35.3108 25.001 35.3108C23.9577 35.3108 23.1119 36.1565 23.1119 37.1998C23.1119 38.2431 23.9577 39.0888 25.001 39.0888Z"
        fill="#7A8FB8"
      />
    </g>
    <defs>
      <clipPath id="clip0_5373:33724">
        <rect width="50" height="50" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
